// import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import ReactLoading from 'react-loading';

function Sloading({width}) {
    return (
        <ReactLoading type='spinningBubbles' className='sLoading' style={{display : 'flex', width : width, margin : 'auto', justifyContent : 'center'}} />
    )
}

export default Sloading;